import { render, staticRenderFns } from "./RegisterBlogArticle.vue?vue&type=template&id=5a41e89c"
import script from "./RegisterBlogArticle.vue?vue&type=script&lang=js"
export * from "./RegisterBlogArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports